import { render, staticRenderFns } from "./YoutubeSearchResults.vue?vue&type=template&id=5955397a&scoped=true"
import script from "./YoutubeSearchResults.vue?vue&type=script&lang=js"
export * from "./YoutubeSearchResults.vue?vue&type=script&lang=js"
import style0 from "./YoutubeSearchResults.vue?vue&type=style&index=0&id=5955397a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955397a",
  null
  
)

export default component.exports